<template>
  <div class="query-detail">
    <!-- 订单详情 -->
    <div v-if="showState===1" class="detail-container">
      <div class="header-nav">
        <div class='header-item'>
          <span>EMS优先邮：{{mailNo}}</span>
          <img
            src="../../assets/img/copy-img.svg"
            v-clipboard:copy="mailNo"
            v-clipboard:success="copyMail"
            v-clipboard:error="copyError"
            alt="copy"
          />
        </div>
      </div>
      <div class="track-list">
        <div class="address">
          <div class="address-container">
            {{mailInfo[0].sendCity}}
            <img class="address-img" src="../../assets/img/way.png" alt="way">
            {{mailInfo[0].receiveCity}}
          </div>
        </div>
        <div class="track-item" v-for="(item,index) in mailInfo" :key="index">
          <div :class="['track-time', {'track-time-first': index === 0}]">
              <div>{{item.dDealDate | timeFilter('YYYY-MM-DD')}}</div>
              <div>{{item.dDealDate | timeFilter('HH:mm') }}</div>
          </div>
          <div class="track-img">
            <!-- 最上面展示橙色圆圈：index === 0;其余展示灰色圆圈-->
            <span :class="['track-icon',{'color-top':index === 0}]"></span>
          </div>
          <div :class="['track-desc', {'track-desc--nofirst': index !== (mailInfo.length-1),'track-time-first': index === 0}]">
            {{item.vDealCity}},{{item.vDealDesc}}
            <!-- 妥投不展示提示信息，非妥投展示最后一条提示信息【轨迹最后一条，即数据第一条】 -->
            <span v-if="!(item.vDealDesc.includes('妥投'))&&index===0">
              {{item.vDealNote?',':''}}
              <span class='desc-note'>{{item.vDealNote}}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="bottom-content" v-if="isShowShare">
        <div class="share" @click.stop="queryShare()">分享</div>
      </div>
    </div>
    <div v-else class="mail-list-center">
      <div class="not-page">
        <!-- 非优先邮 -->
        <div v-if="showState===2">
          <img class="not-page-img" src="../../assets/img/not-page.png" alt />
          <div class="not-page-msg">{{noMailMsg[0]}}</div>
          <div class="not-page-msg">{{noMailMsg[1]}}</div>
        </div>
        <!-- 查无物流信息 -->
        <div v-else-if="showState===3">
          <img class="not-page-img" src="../../assets/img/not-content.svg" alt />
          <div :class="['not-page-msg','color-gray']" >{{noMailMsg[2]}}</div>
        </div>
        <!-- 什么都不展示，只有背景图片 -->
        <div v-else-if="showState===-1">
          <img class="not-page-img2" src="../../assets/img/1561728035.png" alt="">
        </div>
      </div>
    </div>
    <!-- 分享 -->
    <component ref="querySharePopup" :is="querySharePopup"></component>
  </div>
</template>
<script>
import moment from 'moment'
import { setDocumentTitle } from '@/plugin/setTitle/setDocumentTitle.js'
import { shareShortUrl } from '../components/queryShareUrl.js'
import { checkBrowser } from '@/plugin/checkBrowser/checkBrowser.js'
import { getQueryMailDetail } from '../components/queryMailApi'
import shareURLImg from '@/assets/img/shareURLImg.png'
import { Toast } from 'mint-ui'
import doWxConfig from '@/plugin/wxConfig'

export default {
  data () {
    return {
      mailNo: this.$route.params && this.$route.params.mailNo,
      mailInfo: [],
      showState: -1, // -1:什么都不展示,1：订单详情，2:不是优先邮,3:查无物流信息,
      noMailMsg: ['当前邮件非优先邮', '请前往EMS中国邮政速递物流公众号查询', '邮件查无物流信息'],
      shareUrl: '', // 分享链接
      querySharePopup: '', // 分享弹窗组件
      mailTrack: '' // 分享内容
    }
  },
  computed: {
    isShowShare () { // wx才提供分享功能
      let arr = ['WECHAT']
      return arr.includes(checkBrowser())
    }
  },
  created () {
    doWxConfig()
  },
  mounted () {
    setDocumentTitle(`邮件号:${this.$route.params && this.$route.params.mailNo}`)
    this.mailNo = this.$route.params && this.$route.params.mailNo
    this.mailInfo = this.$store.state.mailInfo.mailInfo || []
    this.init()
  },
  filters: {
    timeFilter (value, format) {
      if (!value) {
        return ''
      }
      if (format === 'YYYY-MM-DD') {
        const ymd = moment(value.split(' ')[0]).format('YYYY-MM-DD')
        const today = moment().format('YYYY-MM-DD')
        let yesterday = moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        return ymd === today ? '今天' : (ymd === yesterday ? '昨天' : ymd)
      }
      if (format === 'HH:mm') {
        return moment(value).format('HH:mm')
      }
    }
  },
  methods: {
    copyMail (e) {
      Toast('复制成功')
    },
    copyError (e) {
      Toast('复制失败')
    },
    async init () {
      this.mailInfo = this.$store.state.mailInfo.mailInfo || []
      if (!this.mailNo) {
        return Toast('邮件号不能为空')
      }
      let val = this.mailNo.toUpperCase() // 将邮件号英文字母小写转换成大写
      if (!(/^E[A-Z][0-9]{9}CN$/).test(val)) { // 判断邮件输入格式
        this.showState = 2
        return
      }
      const mailNo = this.mailInfo[0] && this.mailInfo[0].vMailCode
      if (this.mailNo === mailNo) { // 如果vuex存的邮件号和跳转进来邮件号一致，就不用再请求
        if (!this.mailInfo.length) {
          this.showState = 3
          return
        }
        this.showState = 1
        this.onShare()
      } else {
        // 不一致，需要重新请求
        const data = await getQueryMailDetail({ mailNo: this.mailNo })
        if (data && data.code === '000000') {
          if (!data.info.length) { // 查无物流信息
            this.showState = 3
            return
          }
          this.showState = 1
          this.mailInfo = data.info
          this.$store.commit('mailInfo/setMailInfo', data.info || [])
          this.onShare()
        } else if (data && data.code === '100011') { // 非优先邮
          this.showState = 2
        } else {
          Toast((data && data.msg) || '系统开小差，请稍后再试')
        }
      }
    },
    onShare () {
      let _this = this
      const newTick = this.mailInfo && this.mailInfo[0]
      _this.mailTrack = `${newTick.vDealCity},${newTick.vDealDesc}${newTick.vDealNote && !newTick.vDealDesc.includes('妥投') ? ',' + newTick.vDealNote : ''}`
      _this.shareUrl = shareShortUrl(this.mailNo)
      // 需在用户可能点击分享按钮前就先调用
      wx.ready(function () {
      // 分享给朋友
        wx.onMenuShareAppMessage({
          title: `EMS优先邮：${_this.mailNo}`, // 分享标题
          desc: _this.mailTrack, // 分享描述
          link: _this.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: window.location.origin + shareURLImg, // 分享图标
          success: function () {
          // 设置成功
            _this.$refs.querySharePopup.close()
          }
        })
        // 分享到朋友圈接口
        wx.onMenuShareTimeline({
          title: `EMS优先邮：${_this.mailNo}`, // 分享标题
          desc: _this.mailTrack, // 分享描述
          link: _this.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: window.location.origin + shareURLImg, // 分享图标
          success: function () {
            // 用户点击了分享后执行的回调函数
            _this.$refs.querySharePopup.close()
          }
        })
      })
    },
    queryShare () { // 分享按钮
      if (this.isShowShare) {
        if (!this.querySharePopup) {
          this.querySharePopup = () => import(/* webpackChunkName: "sharePopup" */ '../components/querySharePopup.vue')
        } else {
          this.$refs.querySharePopup.open()
        }
      } else {
        this.querySharePopup = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.query-detail {
  height: 100vh;

  .detail-container {
    display: flex;
    height: 100%;
    flex-direction: column;
  }

  .header-nav {
    position: relative;
    color: #b1b1b1;
    font-size: torem(12px);
    line-height: torem(40px);
    padding-bottom:torem(6px);
    background-color: #ebebeb;
    .header-item{
      padding: 0 torem(28px);
      background-color: #fff;
    }

    img {
      margin-left: torem(3px);
    }
  }

  .address {
    background-color: #ebebeb;
    margin-bottom:torem(20px);

    .address-container {
      padding: 0 torem(38px);
      border-bottom: torem(1px) solid #ebebeb;
      background-color: #fff;
      color: #2b2b2b;
      font-size: torem(14px);
      font-weight: bold;
      line-height: torem(50px);

      .address-img {
        margin: 0 16px;
      }
    }
  }

  .track-list {
    overflow: auto;
    overflow-y:scroll;
    flex: 1;
    -webkit-overflow-scrolling: touch;
    margin-bottom:torem(20px);

    .track-item {

      position: relative;
      display: flex;
      padding: 0 torem(10px) torem(20px) torem(12px);
      color: #9b9b9b;

      .track-time {
        display: inline-block;
        width: torem(100px);
        margin-right: torem(16px);
        font-size: torem(12px);
        text-align: end;
      }

      .track-img {
        position: relative;
        width: torem(24px);
        height: torem(24px);

        img {
          width: 100%;
          height: 100%;
        }

        .track-icon {
          display: inline-block;
          width: torem(14px);
          height: torem(14px);
          background-color: #ebebeb;
          border-radius: 50%;
        }

        .color-top {
          background-color: #ffba28;
        }
      }

      .track-desc {
        position: relative;
        flex: 1;
        color: #a5a5a5;
        font-size: torem(14px);
      }

      .track-time-first {
        color: #262626;
      }

      .desc-note {
        color: #ef8200;
      }

      .track-desc--nofirst {
        &::before {
          position: absolute;
          top: torem(22px);
          left: torem(-18px);
          display: block;
          width: 1px;
          height: 80%;
          background-color: #ebebeb;
          content: "";
        }
      }
    }
  }

  .bottom-content {
    width: 100%;
    height: torem(50px);
    align-items: center;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
    color: rgba(38, 38, 38, 1);
    font-size: torem(14px);
    font-weight: 400;

    .share {
      width: torem(70px);
      height: torem(34px);
      border: torem(1px) solid rgba(235, 235, 235, 1);
      margin: torem(8px) torem(10px) 0 0;
      border-radius: torem(17px);
      float: right;
      line-height: torem(34px);
      text-align: center;
    }
  }
  //非优先邮,无物流信息
  .mail-list-center {
    width: 100%;
    height: 100%;

    .not-page {
      color: #ef8200;
      text-align: center;

      .not-page-img {
        width: torem(315px);
        height: torem(180px);
      }

      .not-page-img2 {
        width: torem(123px);
        margin-top: torem(120px);
      }

      .not-page-msg {
        width: 100%;
        margin-top: torem(5px);
        font-size: torem(12px);
      }

      .color-gray {
        color: #9b9b9b;
      }
    }
  }
}
</style>
